import { Button } from '@vrplatform/components';
import { useDashboard, useIsOwnerPortalPreview } from '@vrplatform/data';
import { Logo, Modal } from '@vrplatform/components-legacy';
import { parseAsString, useQueryState } from '@vrplatform/query-params';
import { Box, Center, Text, Title, rem } from '@mantine/core';

function useIsOwnerInviteLoggedInModalOpen() {
  const isOwnerPortalPreview = useIsOwnerPortalPreview();
  const [dashboard] = useDashboard();

  const [invite, setInvite] = useQueryState('invite', parseAsString);

  const opened = !isOwnerPortalPreview && dashboard === 'owner' && !!invite;

  return {
    opened,
    closeModal: () => setInvite(null),
  };
}

export const OwnerInviteLoggedInModal = () => {
  const { opened, closeModal } = useIsOwnerInviteLoggedInModalOpen();

  return (
    <Modal
      opened={opened}
      onClose={closeModal}
      withCloseButton={false}
      size={500}
      styles={{
        body: {
          paddingBlock: rem(40),
          paddingInline: rem(40),
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: rem(48),
        }}
      >
        <Center>
          <Logo width={40} />
        </Center>
        <Box>
          <Title ta="center" size={rem(20)} mb={rem(24)}>
            You are already logged in
          </Title>
          <Text c="neutral" ta="center" size="sm">
            Were you looking to accept an invitation to join a team? Please sign
            out first to accept the invitation.
            <br />
            <br />
            If you are trying to reset your password, please go into your
            settings or use the "Forgot password" link on the sign-in page.
          </Text>
        </Box>

        <Button variant="primary" onClick={closeModal}>
          Close
        </Button>
      </Box>
    </Modal>
  );
};
